import { accountsInitialState } from './accounts/accounts.initial-state';
import { authInitialState } from './auth/auth.initial-state';
import { calendarInitialState } from './calendar/calendar.initial-state';
import { calendar2InitialState } from './calendar2/calendar.initial-state';
import { contactInfoInitialState } from './contact-info/contact-info.initial-state';
import { daemonsInitialState } from './daemons/daemons.initial-state';
import { finesInitialState } from './fines/fines.initial-state';
import { pluginInitialState } from './plugin/plugin.initial-state';
import { reportArchivesInitialState } from './report-archives/report-archives.initial-state';
import { reportsInitialState } from './reports/reports.initial-state';
import { staffInitialState } from './staff/staff.initial-state';
import { statisticsInitialState } from './statistics/statistics.initial-state';
import { transfersInitialState } from './transfers/transfers.initial-state';
import { usersInitialState } from './users/users.initial-state';
import { giftsInitialState } from './gifts/gifts.initial-state';
import { paymentInitialState } from './payment/payment.initial-state';
import { homeInitialState } from './home/home.initial-state';
import { payersInitialState } from './payers/payers.initial-state';
import { dashboardInitialState } from './dashboard/dashboard.initial-state';
import { generalProfileInitialState } from './general/general.initial-state';
import { shareLinksInitialState } from './shared-links/shared-links.initial-state';
import { walletInitialState } from './wallet/wallet.initial-state';
import { chatsInitialState } from './chats/chats.initial-state';

export const initialState = {
  ...authInitialState,
  ...homeInitialState,
  ...reportsInitialState,
  ...accountsInitialState,
  ...usersInitialState,
  ...daemonsInitialState,
  ...pluginInitialState,
  ...staffInitialState,
  ...statisticsInitialState,
  ...calendarInitialState,
  ...calendar2InitialState,
  ...finesInitialState,
  ...transfersInitialState,
  ...reportArchivesInitialState,
  ...contactInfoInitialState,
  ...giftsInitialState,
  ...paymentInitialState,
  ...payersInitialState,
  ...dashboardInitialState,
  ...generalProfileInitialState,
  ...shareLinksInitialState,
  ...walletInitialState,
  ...chatsInitialState,
};
